'use strict';

var _regeneratorRuntime = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _createForOfIteratorHelper = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var LOAD_CODEC = function LOAD_CODEC(codeOrName) {
  return Promise.reject(new Error("No codec found for \"".concat(codeOrName, "\"")));
};

var Multicodecs = /*#__PURE__*/function () {
  function Multicodecs(options) {
    _classCallCheck(this, Multicodecs);

    this._codecsByName = {};
    this._codecsByCode = {};
    this._loadCodec = options.loadCodec || LOAD_CODEC;

    var _iterator = _createForOfIteratorHelper(options.codecs),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var codec = _step.value;
        this.addCodec(codec);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  _createClass(Multicodecs, [{
    key: "addCodec",
    value: function addCodec(codec) {
      if (this._codecsByName[codec.name] || this._codecsByCode[codec.code]) {
        throw new Error("Resolver already exists for codec \"".concat(codec.name, "\""));
      }

      this._codecsByName[codec.name] = codec;
      this._codecsByCode[codec.code] = codec;
    }
  }, {
    key: "removeCodec",
    value: function removeCodec(codec) {
      delete this._codecsByName[codec.name];
      delete this._codecsByCode[codec.code];
    }
  }, {
    key: "getCodec",
    value: function () {
      var _getCodec = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(code) {
        var table, codec;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                table = typeof code === 'string' ? this._codecsByName : this._codecsByCode;

                if (!table[code]) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", table[code]);

              case 3:
                _context.next = 5;
                return this._loadCodec(code);

              case 5:
                codec = _context.sent;

                if (table[code] == null) {
                  this.addCodec(codec);
                }

                return _context.abrupt("return", codec);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCodec(_x) {
        return _getCodec.apply(this, arguments);
      }

      return getCodec;
    }()
  }, {
    key: "listCodecs",
    value: function listCodecs() {
      return Object.values(this._codecsByName);
    }
  }]);

  return Multicodecs;
}();

exports.Multicodecs = Multicodecs;